export enum ThemeModes {
  LIGHT = "light",
  DARK = "dark",
}

export type ThemeMode = `${ThemeModes}`;
